import { render, staticRenderFns } from "./priority-config.vue?vue&type=template&id=7fd11d64&scoped=true"
import script from "./priority-config.vue?vue&type=script&lang=js"
export * from "./priority-config.vue?vue&type=script&lang=js"
import style0 from "./priority-config.vue?vue&type=style&index=0&id=7fd11d64&prod&lang=scss"
import style1 from "./priority-config.vue?vue&type=style&index=1&id=7fd11d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd11d64",
  null
  
)

export default component.exports